<div id="orderConfirm" class="ya-typography">
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <div class="inline-icon margin-down" inlineSVG="shop-icons.svg#ya-hypersoft-bestellen-bestaetigung2"></div>
    <div class="title margin-down" langkey="phOrderResult_ThankYouForYourOrder"></div>
    <ng-container *ngIf="isGroupOrder; then groupOrderConfirm else defaultConfirm">
    </ng-container>
    <ng-template #groupOrderConfirm>
      <div class="text margin-down" [innerHTML]="groupOrderConfirm_HTML">
      </div>
      <div class="text margin-down">{{orderConfirm_Subtext}}</div>
      <div class="ya-webshop-button-container">
        <button mat-flat-button (click)="openInHouseLandingPage()">
          <span langkey="phInHouse_Continue_Btn"></span>
        </button>
      </div>
    </ng-template>
    <ng-template #defaultConfirm>
      <div class="text margin-down" [innerHTML]="orderResult_HTML">
      </div>
      <div class="text margin-down">{{orderConfirm_Subtext}}</div>
      <div class="ya-webshop-button-container">
        <button mat-flat-button (click)="openInHouseLandingPage()">
          <span langkey="phInHouse_Continue_Btn"></span>
        </button>
      </div>
    </ng-template>
  </div>
</div>